import { TextField } from '@radix-ui/themes';
import { useState } from 'react';

interface TimeInputProps {
  onBlur?: (value: string) => void;
  onEnter?: (value: string) => void;
  defaultValue?: string;
}

function parseTime(raw: string): string | null {
  if (!raw || !/\d/.test(raw)) return null;

  const digits = raw.replace(/\D/g, '');

  let hours: number | undefined;
  let minutes: number | undefined;

  if (digits.length <= 2) {
    hours = parseInt(digits, 10);
    minutes = 0;
  } else {
    hours = parseInt(digits.slice(0, 2), 10);
    minutes = parseInt(digits.slice(2, 4), 10);
  }

  const h = Math.min(Number.isNaN(hours) ? 0 : hours, 23);
  const m = Math.min(Number.isNaN(minutes) ? 0 : minutes, 59);

  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export default function TimeInput({ onBlur, onEnter, defaultValue }: TimeInputProps) {
  const [value, setValue] = useState(defaultValue ? (parseTime(defaultValue) ?? '') : '');

  function handleBlur() {
    const formatted = parseTime(value) ?? '';
    setValue(formatted);
    onBlur?.(formatted);
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      const formatted = parseTime(value) ?? '';
      setValue(formatted);
      onEnter?.(formatted);
    }
  }

  return (
    <TextField.Root
      type='text'
      value={value}
      onChange={e => setValue(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      placeholder='00:00'
      maxLength={5}
    />
  );
}
